import { configureStore } from '@reduxjs/toolkit'; 
import rootReducer from './reducers';

let resetTimerGlobal = null;

export const setResetTimerFunction = (fn) => {
  resetTimerGlobal = fn;
};

const resetTimerMiddleware = (store) => (next) => (action) => {
  if (resetTimerGlobal) {
    resetTimerGlobal(); 
  }
  return next(action);
};

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => 
    getDefaultMiddleware().concat(resetTimerMiddleware),
});

export default store;